import "../assets/scss/custom/_custom.scss";

const Spinner = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 spinner" style={{position: 'absolute', width: '100%', top: 0, backgroundColor: '#eeeeee75', zIndex: '999', left: 0}}>
      <div className="spinner-border text-secondary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Spinner;
